import { FileChooserService } from './file-chooser.service';

export default angular
  .module('sfMobile.services.file-chooser', [])
  .service('fileChooserService', FileChooserService).name;
